import { Injectable } from "@angular/core";

// Handle Autoplay Policy
// https://developer.chrome.com/blog/autoplay

@Injectable()
export class RoomInvitationFirstService {
  invitationFirstIsDone = false;
}
